export const STR = {
  fr: {
    brand: {
      tagline: "L'ingénierie mécanique comme art.",
      taglineCaps: "L'INGÉNIERIE MÉCANIQUE COMME ART",
      subtitleHeader: "ATELIER MÉCANIQUE · ŒUVRES ORIGINALES",
      subtitleCaps: "ATELIER MÉCANIQUE — ŒUVRES ORIGINALES",
      eyebrow: "Atelier Mécanique — Œuvres originales",
    },
    marquee: ["MÉCANIQUE COMME ART", "DESSIN TECHNIQUE ORIGINAL", "ÉDITIONS LIMITÉES SUR TOILE", "ATELIER DEMOIVRE", "ENCRE & GÉOMÉTRIE", "PIÈCES UNIQUES SIGNÉES"],
    lightbox: {
      open: "ZOOM",
      close: "Fermer",
      zoomIn: "Agrandir",
      zoomOut: "Réduire",
      reset: "Réinitialiser",
      hint: "MOLETTE OU DOUBLE-CLIC POUR ZOOMER · GLISSER POUR DÉPLACER · ÉCHAP POUR FERMER",
    },
    diag: {
      title: "DIAGNOSTIC SYSTÈME",
      boot: "Initialisation du diagnostic de marge…",
      fallback: "Forfait expédition de secours :",
      secure: "verrouillé sur la marge de référence",
      anomaly: "ANOMALIE DE CALIBRATION — attendu",
      handling: "Manutention & emballage :",
      ups: "Tarification UPS :",
      connected: "connectée",
      upsFallback: "non configurée — forfait appliqué",
      stripe: "Passerelle de paiement Stripe :",
      done: "Diagnostic terminé — aucune anomalie.",
      doneWarn: "Diagnostic terminé — anomalie détectée.",
      unreachable: "Serveur injoignable — diagnostic interrompu.",
      statusOk: "NOMINAL",
      statusWarn: "ANOMALIE",
      statusErr: "HORS LIGNE",
    },
    nav: {
      home: "Accueil",
      shop: "Collection",
      portfolio: "Portfolio",
      process: "Procédé",
      about: "La Maison",
      commissions: "Commissions",
      admin: "ESPACE ATELIER",
    },
    footer: {
      blurb:
        "Toiles originales dessinées à la main — géométrie mécanique, cotes et projections orthographiques, élevées au rang d'œuvre d'art.",
      atelier: "Atelier",
      contact: "Contact",
      shop: "COLLECTION",
      portfolio: "PORTFOLIO",
      process: "PROCÉDÉ",
      about: "LA MAISON",
      commissions: "COMMISSIONS",
      admin: "ESPACE ATELIER",
      rights: "© 2026 DEMOIVRE — TOILES ORIGINALES · PIÈCES UNIQUES",
    },
    newsletter: {
      title: "La lettre de l'atelier",
      text: "Soyez informé des nouvelles toiles avant leur mise en vente.",
      placeholder: "votre@email.com",
      cta: "S'INSCRIRE",
      ok: "Inscription confirmée.",
      already: "Vous êtes déjà inscrit.",
      err: "Inscription impossible pour le moment.",
      thanks: "MERCI — VOUS SEREZ INFORMÉ DES PROCHAINES TOILES.",
    },
    share: {
      label: "PARTAGER",
      copy: "Copier le lien",
      copied: "Lien copié.",
      copyErr: "Impossible de copier le lien.",
    },
    seo: {
      home: "DEMOIVRE — toiles originales dessinées à la main où la géométrie mécanique, les cotes et les projections orthographiques deviennent œuvre d'art. Pièces uniques, atelier Paris.",
      shopTitle: "Collection",
      shop: "Toiles originales DEMOIVRE à acquérir : dessin technique, mécanique et géométrie sur toile de lin. Pièces uniques signées, certificat d'authenticité.",
      portfolioTitle: "Portfolio",
      portfolio: "Études et pièces de l'atelier DEMOIVRE — l'idée mécanique derrière chaque toile.",
      processTitle: "Procédé",
      process: "Du bureau d'études à la toile : analyse mécanique, mise au trait à la main, encrage sur lin brut.",
      aboutTitle: "La Maison",
      about: "DEMOIVRE, atelier parisien où l'ingénierie mécanique devient art. Mechanical Engineering as Art.",
      contactTitle: "Commissions",
      contact: "Commandez une toile sur mesure de votre machine, véhicule ou mécanisme — atelier DEMOIVRE.",
    },
    home: {
      intro:
        "Des toiles originales, dessinées à la main, où la géométrie des machines — cotes, coupes, projections orthographiques — devient une œuvre d'art.",
      ctaCollection: "VOIR LA COLLECTION",
      ctaCommission: "COMMANDER UNE PIÈCE",
      scroll: "DÉFILER ↓",
      manifestoEyebrow: "Le Manifeste",
      manifestoTitleA: "Trois chapitres, une conviction :",
      manifestoTitleB: "la machine est déjà une œuvre.",
      chapterLabel: "CHAPITRE",
      ch1t: "La Machine",
      ch1x:
        "Chaque moteur, chaque boîte de vitesses, chaque châssis est une sculpture déjà aboutie. DeMoivre ne fait que révéler la géométrie que l'ingénieur y a cachée.",
      ch1m: "MÉCANIQUE · CINÉMATIQUE · SYSTÈMES",
      ch2t: "Le Trait",
      ch2x:
        "Projections orthographiques, axes de centrage, cotes fonctionnelles — le vocabulaire du bureau d'études, tracé à la main avec la rigueur du plan d'exécution.",
      ch2m: "ISO 128 · ORTHOGRAPHIQUE · COTATION",
      ch3t: "La Toile",
      ch3x:
        "L'encre rencontre le lin brut. Le dessin technique quitte l'écran et devient objet — une pièce unique, numérotée comme un plan, signée comme une œuvre.",
      ch3m: "ENCRE · LIN BRUT · PIÈCE UNIQUE",
      collectionEyebrow: "La Collection",
      collectionTitle: "Pièces disponibles",
      collectionAll: "TOUTE LA COLLECTION",
      loading: "CHARGEMENT…",
      noPieces: "LE CATALOGUE EST EN PRÉPARATION — L'ATELIER AJOUTE SES PIÈCES",
      atelierEyebrow: "L'Atelier",
      atelierTitleA: "Du bureau d'études",
      atelierTitleB: "à la toile.",
      atelierText:
        "Chaque pièce naît d'une analyse mécanique réelle — cinématique, rapports de transmission, géométrie de suspension — puis est mise au trait à la main, cote par cote, jusqu'à l'encrage final sur lin brut.",
      atelierCta: "DÉCOUVRIR LE PROCÉDÉ",
      ctaEyebrow: "Commissions",
      ctaScript: "Votre machine,",
      ctaSerif: "dessinée comme une œuvre.",
      ctaText:
        "Un moteur qui compte pour vous, une voiture de famille, un prototype — l'atelier réalise des pièces uniques sur commande.",
      ctaButton: "ÉCRIRE À L'ATELIER",
    },
    shop: {
      eyebrow: "La Collection",
      title: "Toiles originales",
      intro:
        "Chaque pièce est unique — encre et graphite sur lin brut, numérotée comme un plan d'exécution. Une fois acquise, elle n'est jamais reproduite.",
      count: "{n} PIÈCES RÉFÉRENCÉES — CATALOGUE {y}",
      empty: "LE CATALOGUE EST EN PRÉPARATION — REVENEZ BIENTÔT",
    },
    avail: {
      "In Atelier": "Disponible — À l'atelier",
      Unavailable: "Indisponible",
      Reserved: "Réservée",
      Sold: "Acquise",
    },
    product: {
      loading: "CHARGEMENT…",
      notFound: "Pièce introuvable.",
      back: "← RETOUR À LA COLLECTION",
      collectionLabel: "LA COLLECTION",
      noPhoto: "PHOTOGRAPHIE À VENIR",
      prevPhoto: "Photo précédente",
      nextPhoto: "Photo suivante",
      goToPhoto: "Aller à la photo",
      idea: "L'IDÉE MÉCANIQUE",
      dimensions: "DIMENSIONS",
      edition: "ÉDITION",
      year: "ANNÉE",
      drawingNo: "DESSIN Nº",
      format: "FORMAT",
      formatValue: "Toile physique originale",
      framing: "ENCADREMENT",
      framingValue: "Entièrement encadrée en or muséal premium (accroche par câble, prête à installer)",
      editionValue: "Œuvre originale",
      priceOnRequest: "PRIX SUR DEMANDE",
      addTo: "AJOUTER À LA COLLECTION",
      reserved: "PIÈCE RÉSERVÉE",
      acquired: "PIÈCE ACQUISE",
      unavailable: "PIÈCE INDISPONIBLE",
      certNote:
        "CERTIFICAT D'AUTHENTICITÉ DWG INCLUS · EXPÉDITION SOIGNÉE DEPUIS L'ATELIER",
      commissionCta: "COMMANDER UNE PIÈCE DANS CET ESPRIT →",
      originalCanvas: "TOILE ORIGINALE",
    },
    portfolio: {
      eyebrow: "Portfolio",
      title: "Études terminées",
      intro:
        "Chaque toile est précédée d'une analyse mécanique. Voici les pièces de l'atelier et l'idée d'ingénierie qui les a engendrées.",
      study: "ÉTUDE",
      view: "VOIR LA PIÈCE →",
      empty: "LES ÉTUDES SERONT PUBLIÉES PROCHAINEMENT",
    },
    process: {
      eyebrow: "Le Procédé",
      titleA: "De la géométrie",
      titleB: "à la toile.",
      intro:
        "Quatre phases, du manuel technique à l'encrage final. La méthode d'un bureau d'études, appliquée à une œuvre d'art.",
      phase: "PHASE",
      dimLabel: "PROCÉDÉ — 4 PHASES",
      steps: [
        {
          title: "Conception",
          text: "Chaque pièce commence par le choix d'une machine — un moteur, une boîte de vitesses, un châssis. L'atelier rassemble plans d'époque, manuels techniques et relevés pour comprendre le système avant de le dessiner.",
          tags: "RECHERCHE · PLANS D'ÉPOQUE · RELEVÉS",
        },
        {
          title: "Analyse cinématique",
          text: "Le mécanisme est décomposé : chaînes de transmission, rapports, courses, angles. Les vues sont choisies comme un ingénieur choisit ses projections — plan, élévation, coupe — pour révéler la logique du système.",
          tags: "CINÉMATIQUE · VUES ÉCLATÉES · COUPES",
        },
        {
          title: "Mise au trait",
          text: "Le dessin est construit à la main selon les conventions du dessin industriel : axes de centrage en traits mixtes, cotes fonctionnelles, hachurages à 45°, cartouches. La rigueur d'AutoCAD, la sensibilité de la main.",
          tags: "ISO 128 · COTATION · TRAITS MIXTES",
        },
        {
          title: "Encre & toile",
          text: "La mise au trait est reportée sur toile de lin brut, puis encrée. Le grain du lin reste visible sous le trait — le plan devient matière. Chaque pièce est numérotée d'un numéro de dessin et signée.",
          tags: "ENCRE DE CHINE · LIN BRUT · NUMÉROTATION DWG",
        },
      ],
    },
    about: {
      eyebrow: "La Maison",
      title: "DeMoivre est née d'une conviction simple.",
      quote: "« Le dessin d'un moteur est déjà une œuvre — il ne manquait qu'un cadre. »",
      p1: "L'ingénierie mécanique possède sa propre beauté : la géométrie d'une came, la triangulation d'un châssis, l'élégance d'une coupe hachurée. Pendant un siècle, les bureaux d'études ont produit des dessins d'une rigueur et d'une grâce extraordinaires — destinés à l'usine, jamais au mur.",
      p2: "DeMoivre existe pour réunir ces deux mondes : la culture du dessin technique français — la projection orthographique, la cotation, le cartouche — et la tradition de la toile originale, unique, faite main.",
      p3: "Chaque pièce est dessinée à la main, à l'encre, sur toile de lin brut. Aucune impression, aucune reproduction : un dessin est une pièce, comme un plan porte un seul numéro.",
      closing1: "La machine comme sujet. Le dessin comme langage.",
      closing2: "La toile comme destin.",
      cta: "DÉCOUVRIR LA COLLECTION",
      imageCaption: "L'ATELIER — VUE Nº 01",
    },
    contact: {
      eyebrow: "Commissions & Contact",
      titleA: "Commander",
      titleB: "une pièce unique.",
      intro:
        "Un moteur qui a compté, une voiture de famille, un prototype — décrivez la machine, l'atelier étudie le sujet et vous propose une mise au trait avant l'encrage.",
      steps: [
        "01 — DÉCRIVEZ LA MACHINE OU LE SYSTÈME",
        "02 — L'ATELIER PROPOSE UNE ÉTUDE & UN FORMAT",
        "03 — MISE AU TRAIT, PUIS ENCRAGE SUR TOILE",
        "04 — CERTIFICAT DWG & EXPÉDITION SOIGNÉE",
      ],
      replyNote: "L'atelier répond personnellement à chaque demande.",
      directTitle: "CONTACT DIRECT",
      buttonLabel: "CONTACT",
      namePh: "NOM COMPLET",
      emailPh: "ADRESSE E-MAIL",
      type: {
        commission: "Commission d'une œuvre",
        question: "Question sur une pièce",
        press: "Presse & expositions",
      },
      archetypePh: "ARCHETYPE MÉCANIQUE — EX. MOTEUR V12, STREAMLINER 1937",
      messagePh: "VOTRE PROJET — LA MACHINE, SON HISTOIRE, CE QU'ELLE REPRÉSENTE POUR VOUS",
      submit: "TRANSMETTRE À L'ATELIER →",
      sending: "ENVOI…",
      toastOk: "Demande transmise à l'atelier.",
      toastErr: "L'envoi a échoué. Réessayez.",
    },
    cart: {
      title: "Votre Collection",
      subtitle: "PIÈCES UNIQUES — SÉLECTIONNÉES",
      emptyTitle: "Votre collection est vide.",
      emptyNote: "CHAQUE TOILE EST UNE PIÈCE UNIQUE",
      total: "TOTAL",
      checkout: "FINALISER L'ACQUISITION →",
      simulated: "PAIEMENT SÉCURISÉ PAR CARTE · STRIPE",
    },
    checkout: {
      eyebrow: "Acquisition — Paiement sécurisé",
      certificate: "CERTIFICAT D'AUTHENTICITÉ",
      orderConfirmed: "Commande {id} confirmée",
      sentTo: "Une confirmation a été envoyée à",
      preparesNote: "L'atelier prépare personnellement chaque expédition.",
      print: "IMPRIMER LE CERTIFICAT",
      done: "TERMINER",
      included: "INCLUSE",
      shippingLabel: "Expédition & manutention",
      totalLabel: "TOTAL",
      addressTitle: "ADRESSE DE LIVRAISON",
      addressHint: "Le tarif de transport UPS est calculé en direct pour votre adresse.",
      namePh: "NOM COMPLET",
      emailPh: "E-MAIL",
      addressPh: "ADRESSE",
      address2Ph: "COMPLÉMENT (OPTIONNEL)",
      cityPh: "VILLE",
      statePh: "ÉTAT / PROVINCE",
      postalPh: "CODE POSTAL",
      residential: "ADRESSE RÉSIDENTIELLE",
      getQuote: "CALCULER LA LIVRAISON",
      quoting: "CALCUL EN COURS…",
      quoteErr: "Impossible de calculer la livraison. Vérifiez l'adresse.",
      editAddress: "MODIFIER L'ADRESSE",
      fallbackService: "Expédition assurée — forfait",
      handling: "Manutention & emballage",
      stripeNote: "Vous allez être redirigé vers notre page de paiement sécurisée (Stripe) pour régler par carte. Les taxes applicables sont calculées à cette étape.",
      pay: "PAYER PAR CARTE",
      redirecting: "REDIRECTION…",
      secured: "PAIEMENT CHIFFRÉ · STRIPE",
      toastErr: "Le paiement n'a pas pu démarrer. Réessayez.",
    },
    payment: {
      successTitle: "Paiement confirmé",
      checking: "VÉRIFICATION DU PAIEMENT…",
      failed: "PAIEMENT NON ABOUTI",
      error: "VÉRIFICATION IMPOSSIBLE",
      timeout: "PAIEMENT EN COURS DE CONFIRMATION",
      contactNote: "Si votre carte a été débitée, votre certificat vous sera envoyé par e-mail. Contactez l'atelier en cas de doute.",
      contactCta: "CONTACTER L'ATELIER",
      cancelTitle: "Paiement annulé",
      cancelNote: "Aucun débit n'a été effectué. La toile est de nouveau disponible — vous pouvez reprendre à tout moment.",
      retry: "REPRENDRE LE PAIEMENT",
      backShop: "RETOUR À LA COLLECTION",
    },
    admin: {
      access: "ESPACE ATELIER — ACCÈS PRIVÉ",
      passwordPh: "MOT DE PASSE",
      enter: "ENTRER",
      welcome: "Bienvenue à l'atelier.",
      wrongPw: "Mot de passe incorrect.",
      eyebrow: "Espace Atelier",
      title: "Gestion du catalogue",
      logout: "QUITTER",
      tabArtworks: "CATALOGUE",
      tabOrders: "COMMANDES",
      tabInquiries: "DEMANDES",
      tabSite: "SITE & CONTACTS",
      contactsTitle: "Coordonnées de l'atelier",
      contactsHint: "Affichées dans le pied de page et sur la page Commissions. Laissez vide ce que vous ne souhaitez pas publier.",
      fContactEmail: "E-MAIL DE CONTACT",
      fContactPhone: "TÉLÉPHONE (ex. +1 713 555 0100)",
      fContactWhatsapp: "WHATSAPP (numéro international)",
      fContactHours: "HORAIRES (ex. Lun–Ven 9h–18h CST)",
      fContactAddress: "ADRESSE POSTALE (plusieurs lignes possibles)",
      sitePhotoTitle: "Photo de l'atelier — page d'accueil",
      sitePhotoHint: "Cette photo apparaît dans la section « Du bureau d'études à la toile » de l'accueil. Format paysage 4:3 recommandé.",
      sitePhotoEmpty: "AUCUNE PHOTO — LE BLOC AFFICHE UN CADRE VIDE",
      sitePhotoRemove: "RETIRER LA PHOTO",
      sitePhotoSaved: "Photo de l'atelier enregistrée.",
      tabShipping: "LIVRAISON",
      shippingSaved: "Réglages de livraison enregistrés.",
      upsTitle: "UPS — Tarification en direct",
      upsConfigured: "CONNECTÉ",
      upsNotConfigured: "NON CONFIGURÉ",
      upsHint: "Identifiants de votre application UPS Developer (API Rating). Ils sont chiffrés avant stockage et ne sont jamais renvoyés au navigateur. Laissez un champ vide pour conserver la valeur existante.",
      upsAccount: "N° DE COMPTE UPS (6 car.)",
      upsClientId: "CLIENT ID",
      upsClientSecret: "CLIENT SECRET",
      upsEnvTest: "Environnement de test (CIE)",
      upsEnvProd: "Production",
      upsTest: "TESTER LA CONNEXION",
      upsClear: "SUPPRIMER LES IDENTIFIANTS",
      shipFromTitle: "Adresse d'expédition de l'atelier",
      feesTitle: "Frais & colis",
      feesHint: "Les frais de manutention sont ajoutés au tarif UPS en direct pour former une seule ligne « Expédition & manutention » au paiement. Le forfait de secours s'applique si UPS est injoignable. Le tarif UPS est converti en euros au cours du jour (BCE).",
      fHandling: "MANUTENTION & EMBALLAGE (€)",
      fFallback: "FORFAIT DE SECOURS SI UPS INJOIGNABLE (€)",
      fWeight: "POIDS DU COLIS PAR TOILE (KG)",
      fDepth: "ÉPAISSEUR DU COLIS (CM)",
      paidLabel: "PAYÉE",
      availableBtn: "DISPONIBLE",
      slidesHint: "PLUSIEURS PHOTOS POSSIBLES — LA PREMIÈRE EST LA COUVERTURE",
      cover: "COUV.",
      unavailableBtn: "INDISPONIBLE",
      toggleAvailHint: "Basculer disponible / indisponible",
      tabSubscribers: "ABONNÉS",
      noSubscribers: "Aucun abonné pour le moment.",
      exportCsv: "EXPORTER CSV",
      visibilityTitle: "Visibilité & réseaux",
      visibilityHint: "Renseignez l'adresse publique du site (ex. https://demoivre.com) pour les aperçus de liens et le plan du site, puis vos réseaux — les icônes apparaissent dans le pied de page.",
      fSiteUrl: "ADRESSE PUBLIQUE DU SITE (https://…)",
      fGoogle: "CODE GOOGLE SEARCH CONSOLE (balise meta, optionnel)",
      saveSettings: "ENREGISTRER",
      settingsSaved: "Réglages enregistrés.",
      seoHelpTitle: "Référencement Google",
      seoHelp1: "Plan du site à soumettre dans Google Search Console :",
      seoHelp2: "Lien de partage de l'accueil (aperçu riche) :",
      seoHelp3: "Chaque toile possède son propre lien de partage via les boutons « Partager » de sa page.",
      addPiece: "AJOUTER UNE PIÈCE",
      editPiece: "MODIFIER",
      newPiece: "NOUVELLE PIÈCE",
      fTitle: "TITRE",
      fDwg: "DESSIN Nº — EX. DWG-2026-FR-007",
      fDimensions: "DIMENSIONS — EX. 40.6 × 50.8 CM / 16 × 20 IN",
      fPrice: "PRIX EUR",
      fMedium: "MEDIUM",
      fYear: "ANNÉE",
      fEdition: "ÉDITION",
      fImage: "URL PHOTOGRAPHIE (PLACEHOLDER ACCEPTÉ)",
      fDescription: "DESCRIPTION",
      fStory: "L'IDÉE MÉCANIQUE / HISTOIRE DU DESSIN",
      enSection: "TRADUCTIONS ANGLAISES (OPTIONNEL)",
      fTitleEn: "TITRE — ANGLAIS",
      fMediumEn: "MEDIUM — ANGLAIS",
      fEditionEn: "ÉDITION — ANGLAIS",
      fDescriptionEn: "DESCRIPTION — ANGLAIS",
      fStoryEn: "IDÉE MÉCANIQUE — ANGLAIS",
      uploadLabel: "TÉLÉVERSER UNE PHOTO",
      uploading: "ENVOI…",
      uploadOk: "Photo téléversée.",
      uploadErr: "Échec du téléversement.",
      orUrl: "OU COLLER UNE URL D'IMAGE PUIS ENTRÉE",
      featured: "PIÈCE EN VEDETTE (PAGE D'ACCUEIL)",
      save: "ENREGISTRER",
      cancel: "ANNULER",
      saved: "Pièce mise à jour.",
      created: "Pièce ajoutée au catalogue.",
      saveErr: "Échec de l'enregistrement.",
      deleted: "Pièce retirée du catalogue.",
      deleteErr: "Échec de la suppression.",
      noOrders: "AUCUNE COMMANDE POUR L'INSTANT",
      noInquiries: "AUCUNE DEMANDE POUR L'INSTANT",
      archetype: "Archétype :",
      format: "Format :",
    },
    store: {
      alreadyIn: "Cette pièce est déjà dans votre collection.",
      added: "Toile ajoutée à votre collection.",
    },
  },
  en: {
    brand: {
      tagline: "Mechanical Engineering as Art.",
      taglineCaps: "MECHANICAL ENGINEERING AS ART",
      subtitleHeader: "MECHANICAL ATELIER · ORIGINAL WORKS",
      subtitleCaps: "MECHANICAL ATELIER — ORIGINAL WORKS",
      eyebrow: "Mechanical Atelier — Original works",
    },
    marquee: ["MECHANICAL ENGINEERING AS ART", "ORIGINAL TECHNICAL DRAWING", "LIMITED EDITIONS ON CANVAS", "DEMOIVRE ATELIER", "INK & GEOMETRY", "SIGNED UNIQUE PIECES"],
    lightbox: {
      open: "ZOOM",
      close: "Close",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out",
      reset: "Reset",
      hint: "SCROLL OR DOUBLE-CLICK TO ZOOM · DRAG TO PAN · ESC TO CLOSE",
    },
    diag: {
      title: "SYSTEM DIAGNOSTIC",
      boot: "Initialising margin diagnostic…",
      fallback: "Fallback shipping rate:",
      secure: "locked on reference margin",
      anomaly: "CALIBRATION ANOMALY — expected",
      handling: "Handling & packaging:",
      ups: "UPS rating:",
      connected: "connected",
      upsFallback: "not configured — flat rate applied",
      stripe: "Stripe payment gateway:",
      done: "Diagnostic complete — no anomalies.",
      doneWarn: "Diagnostic complete — anomaly detected.",
      unreachable: "Server unreachable — diagnostic aborted.",
      statusOk: "NOMINAL",
      statusWarn: "ANOMALY",
      statusErr: "OFFLINE",
    },
    nav: {
      home: "Home",
      shop: "Collection",
      portfolio: "Portfolio",
      process: "Process",
      about: "The House",
      commissions: "Commissions",
      admin: "PRIVATE ATELIER",
    },
    footer: {
      blurb:
        "Original hand-drawn canvases — mechanical geometry, dimensions and orthographic projections elevated to the rank of art.",
      atelier: "Atelier",
      contact: "Contact",
      shop: "COLLECTION",
      portfolio: "PORTFOLIO",
      process: "PROCESS",
      about: "THE HOUSE",
      commissions: "COMMISSIONS",
      admin: "PRIVATE ATELIER",
      rights: "© 2026 DEMOIVRE — ORIGINAL CANVASES · UNIQUE PIECES",
    },
    newsletter: {
      title: "The atelier letter",
      text: "Hear about new canvases before they go on sale.",
      placeholder: "your@email.com",
      cta: "SUBSCRIBE",
      ok: "Subscription confirmed.",
      already: "You are already subscribed.",
      err: "Subscription failed, please try again.",
      thanks: "THANK YOU — YOU'LL HEAR ABOUT THE NEXT CANVASES.",
    },
    share: {
      label: "SHARE",
      copy: "Copy link",
      copied: "Link copied.",
      copyErr: "Could not copy the link.",
    },
    seo: {
      home: "DEMOIVRE — original hand-drawn canvases where mechanical geometry, dimensions and orthographic projections become art. Unique pieces, Paris atelier.",
      shopTitle: "Collection",
      shop: "Original DEMOIVRE canvases for sale: technical drawing, mechanics and geometry on linen. Signed unique pieces with certificate of authenticity.",
      portfolioTitle: "Portfolio",
      portfolio: "Studies and pieces from the DEMOIVRE atelier — the mechanical idea behind each canvas.",
      processTitle: "Process",
      process: "From the drawing office to the canvas: mechanical analysis, hand line work, inking on raw linen.",
      aboutTitle: "The House",
      about: "DEMOIVRE, a Paris atelier where mechanical engineering becomes art. Mechanical Engineering as Art.",
      contactTitle: "Commissions",
      contact: "Commission a bespoke canvas of your machine, vehicle or mechanism — DEMOIVRE atelier.",
    },
    home: {
      intro:
        "Original hand-drawn canvases where the geometry of machines — dimensions, sections, orthographic projections — becomes a work of art.",
      ctaCollection: "VIEW THE COLLECTION",
      ctaCommission: "COMMISSION A PIECE",
      scroll: "SCROLL ↓",
      manifestoEyebrow: "The Manifesto",
      manifestoTitleA: "Three chapters, one conviction:",
      manifestoTitleB: "the machine is already a work of art.",
      chapterLabel: "CHAPTER",
      ch1t: "The Machine",
      ch1x:
        "Every engine, every gearbox, every chassis is already a finished sculpture. DeMoivre simply reveals the geometry the engineer hid inside it.",
      ch1m: "MECHANICS · KINEMATICS · SYSTEMS",
      ch2t: "The Line",
      ch2x:
        "Orthographic projections, centrelines, functional dimensions — the vocabulary of the engineering office, drawn by hand with the rigour of a production drawing.",
      ch2m: "ISO 128 · ORTHOGRAPHIC · DIMENSIONING",
      ch3t: "The Canvas",
      ch3x:
        "Ink meets raw linen. The technical drawing leaves the screen and becomes an object — a unique piece, numbered like a plan, signed like a work.",
      ch3m: "INK · RAW LINEN · UNIQUE PIECE",
      collectionEyebrow: "The Collection",
      collectionTitle: "Available pieces",
      collectionAll: "FULL COLLECTION",
      loading: "LOADING…",
      noPieces: "THE CATALOGUE IS IN PREPARATION — THE ATELIER IS ADDING ITS PIECES",
      atelierEyebrow: "The Atelier",
      atelierTitleA: "From the design office",
      atelierTitleB: "to the canvas.",
      atelierText:
        "Each piece begins with a real mechanical analysis — kinematics, gear ratios, suspension geometry — then is drafted by hand, dimension by dimension, until the final inking on raw linen.",
      atelierCta: "DISCOVER THE PROCESS",
      ctaEyebrow: "Commissions",
      ctaScript: "Your machine,",
      ctaSerif: "drawn as a work of art.",
      ctaText:
        "An engine that matters to you, a family car, a prototype — the atelier creates unique pieces to order.",
      ctaButton: "WRITE TO THE ATELIER",
    },
    shop: {
      eyebrow: "The Collection",
      title: "Original canvases",
      intro:
        "Each piece is unique — ink and graphite on raw linen, numbered like a production drawing. Once acquired, it is never reproduced.",
      count: "{n} PIECES CATALOGUED — {y} CATALOGUE",
      empty: "THE CATALOGUE IS IN PREPARATION — COME BACK SOON",
    },
    avail: {
      "In Atelier": "Available — In the atelier",
      Unavailable: "Unavailable",
      Reserved: "Reserved",
      Sold: "Acquired",
    },
    product: {
      loading: "LOADING…",
      notFound: "Piece not found.",
      back: "← BACK TO THE COLLECTION",
      collectionLabel: "THE COLLECTION",
      noPhoto: "PHOTOGRAPH COMING SOON",
      prevPhoto: "Previous photo",
      nextPhoto: "Next photo",
      goToPhoto: "Go to photo",
      idea: "THE MECHANICAL IDEA",
      dimensions: "DIMENSIONS",
      edition: "EDITION",
      year: "YEAR",
      drawingNo: "DRAWING NO.",
      format: "FORMAT",
      formatValue: "Original physical canvas",
      framing: "FRAMING",
      framingValue: "Fully framed in premium museum-gold (wire-hung, ready for installation)",
      editionValue: "Original artwork",
      priceOnRequest: "PRICE ON REQUEST",
      addTo: "ADD TO COLLECTION",
      reserved: "PIECE RESERVED",
      acquired: "PIECE ACQUIRED",
      unavailable: "PIECE UNAVAILABLE",
      certNote:
        "DWG CERTIFICATE OF AUTHENTICITY INCLUDED · CAREFULLY SHIPPED FROM THE ATELIER",
      commissionCta: "COMMISSION A PIECE IN THIS SPIRIT →",
      originalCanvas: "ORIGINAL CANVAS",
    },
    portfolio: {
      eyebrow: "Portfolio",
      title: "Completed studies",
      intro:
        "Every canvas is preceded by a mechanical analysis. Here are the atelier's pieces and the engineering idea that gave rise to each one.",
      study: "STUDY",
      view: "VIEW THE PIECE →",
      empty: "STUDIES WILL BE PUBLISHED SOON",
    },
    process: {
      eyebrow: "The Process",
      titleA: "From geometry",
      titleB: "to canvas.",
      intro:
        "Four phases, from the technical manual to the final inking. The method of an engineering design office, applied to a work of art.",
      phase: "PHASE",
      dimLabel: "PROCESS — 4 PHASES",
      steps: [
        {
          title: "Conception",
          text: "Every piece begins with the choice of a machine — an engine, a gearbox, a chassis. The atelier gathers period drawings, technical manuals and measurements to understand the system before drawing it.",
          tags: "RESEARCH · PERIOD DRAWINGS · MEASUREMENTS",
        },
        {
          title: "Kinematic analysis",
          text: "The mechanism is broken down: transmission chains, ratios, travels, angles. Views are chosen the way an engineer chooses projections — plan, elevation, section — to reveal the logic of the system.",
          tags: "KINEMATICS · EXPLODED VIEWS · SECTIONS",
        },
        {
          title: "Drafting the line",
          text: "The drawing is built by hand according to the conventions of technical drawing: centrelines in chain thin lines, functional dimensions, 45° hatching, title blocks. The rigour of AutoCAD, the sensibility of the hand.",
          tags: "ISO 128 · DIMENSIONING · CHAIN LINES",
        },
        {
          title: "Ink & canvas",
          text: "The draft is transferred to raw linen canvas, then inked. The grain of the linen remains visible beneath the line — the drawing becomes matter. Each piece is numbered with a drawing number and signed.",
          tags: "INDIA INK · RAW LINEN · DWG NUMBERING",
        },
      ],
    },
    about: {
      eyebrow: "The House",
      title: "DeMoivre was born of a simple conviction.",
      quote: "“The drawing of an engine is already a work — all it lacked was a frame.”",
      p1: "Mechanical engineering has its own beauty: the geometry of a cam, the triangulation of a chassis, the elegance of a hatched section. For a century, design offices produced drawings of extraordinary rigour and grace — destined for the factory floor, never for the wall.",
      p2: "DeMoivre exists to bring these two worlds together: the French culture of technical drawing — orthographic projection, dimensioning, the title block — and the tradition of the original, unique, handmade canvas.",
      p3: "Every piece is drawn by hand, in ink, on raw linen canvas. No printing, no reproduction: one drawing is one piece, just as a plan bears a single number.",
      closing1: "The machine as subject. The drawing as language.",
      closing2: "The canvas as destiny.",
      cta: "DISCOVER THE COLLECTION",
      imageCaption: "THE ATELIER — VIEW NO. 01",
    },
    contact: {
      eyebrow: "Commissions & Contact",
      titleA: "Commission",
      titleB: "a unique piece.",
      intro:
        "An engine that mattered, a family car, a prototype — describe the machine, the atelier studies the subject and proposes a line draft before inking.",
      steps: [
        "01 — DESCRIBE THE MACHINE OR SYSTEM",
        "02 — THE ATELIER PROPOSES A STUDY & A FORMAT",
        "03 — DRAFTING THE LINE, THEN INKING ON CANVAS",
        "04 — DWG CERTIFICATE & CAREFUL SHIPPING",
      ],
      replyNote: "The atelier personally replies to every inquiry.",
      directTitle: "DIRECT CONTACT",
      buttonLabel: "CONTACT",
      namePh: "FULL NAME",
      emailPh: "EMAIL ADDRESS",
      type: {
        commission: "Commission an artwork",
        question: "Question about a piece",
        press: "Press & exhibitions",
      },
      archetypePh: "MECHANICAL ARCHETYPE — E.G. V12 ENGINE, 1937 STREAMLINER",
      messagePh: "YOUR PROJECT — THE MACHINE, ITS STORY, WHAT IT MEANS TO YOU",
      submit: "SEND TO THE ATELIER →",
      sending: "SENDING…",
      toastOk: "Inquiry sent to the atelier.",
      toastErr: "Sending failed. Please try again.",
    },
    cart: {
      title: "Your Collection",
      subtitle: "UNIQUE PIECES — SELECTED",
      emptyTitle: "Your collection is empty.",
      emptyNote: "EVERY CANVAS IS A UNIQUE PIECE",
      total: "TOTAL",
      checkout: "COMPLETE THE ACQUISITION →",
      simulated: "SECURE CARD PAYMENT · STRIPE",
    },
    checkout: {
      eyebrow: "Acquisition — Secure payment",
      certificate: "CERTIFICATE OF AUTHENTICITY",
      orderConfirmed: "Order {id} confirmed",
      sentTo: "A confirmation has been sent to",
      preparesNote: "The atelier personally prepares every shipment.",
      print: "PRINT THE CERTIFICATE",
      done: "FINISH",
      included: "INCLUDED",
      shippingLabel: "Shipping & handling",
      totalLabel: "TOTAL",
      addressTitle: "SHIPPING ADDRESS",
      addressHint: "The UPS carrier rate is calculated live for your address.",
      namePh: "FULL NAME",
      emailPh: "E-MAIL",
      addressPh: "ADDRESS",
      address2Ph: "APT / SUITE (OPTIONAL)",
      cityPh: "CITY",
      statePh: "STATE / PROVINCE",
      postalPh: "POSTAL CODE",
      residential: "RESIDENTIAL ADDRESS",
      getQuote: "CALCULATE SHIPPING",
      quoting: "CALCULATING…",
      quoteErr: "Could not calculate shipping. Please check the address.",
      editAddress: "EDIT ADDRESS",
      fallbackService: "Insured shipping — flat rate",
      handling: "Handling & packaging",
      stripeNote: "You will be redirected to our secure payment page (Stripe) to pay by card. Applicable taxes are calculated at that step.",
      pay: "PAY BY CARD",
      redirecting: "REDIRECTING…",
      secured: "ENCRYPTED PAYMENT · STRIPE",
      toastErr: "Payment could not start. Please try again.",
    },
    payment: {
      successTitle: "Payment confirmed",
      checking: "VERIFYING PAYMENT…",
      failed: "PAYMENT NOT COMPLETED",
      error: "VERIFICATION UNAVAILABLE",
      timeout: "PAYMENT STILL BEING CONFIRMED",
      contactNote: "If your card was charged, your certificate will be emailed to you. Contact the atelier if in doubt.",
      contactCta: "CONTACT THE ATELIER",
      cancelTitle: "Payment cancelled",
      cancelNote: "No charge was made. The canvas is available again — you can resume at any time.",
      retry: "RESUME PAYMENT",
      backShop: "BACK TO THE COLLECTION",
    },
    admin: {
      access: "PRIVATE ATELIER — RESTRICTED ACCESS",
      passwordPh: "PASSWORD",
      enter: "ENTER",
      welcome: "Welcome to the atelier.",
      wrongPw: "Incorrect password.",
      eyebrow: "Atelier Area",
      title: "Catalogue management",
      logout: "LOG OUT",
      tabArtworks: "CATALOGUE",
      tabOrders: "ORDERS",
      tabInquiries: "INQUIRIES",
      tabSite: "SITE & CONTACTS",
      contactsTitle: "Atelier contact details",
      contactsHint: "Shown in the footer and on the Commissions page. Leave empty anything you don't want published.",
      fContactEmail: "CONTACT E-MAIL",
      fContactPhone: "PHONE (e.g. +1 713 555 0100)",
      fContactWhatsapp: "WHATSAPP (international number)",
      fContactHours: "HOURS (e.g. Mon–Fri 9am–6pm CST)",
      fContactAddress: "POSTAL ADDRESS (multiple lines allowed)",
      sitePhotoTitle: "Atelier photo — home page",
      sitePhotoHint: "This photo appears in the “From the drawing office to the canvas” section of the home page. Landscape 4:3 recommended.",
      sitePhotoEmpty: "NO PHOTO — THE BLOCK SHOWS AN EMPTY FRAME",
      sitePhotoRemove: "REMOVE PHOTO",
      sitePhotoSaved: "Atelier photo saved.",
      tabShipping: "SHIPPING",
      shippingSaved: "Shipping settings saved.",
      upsTitle: "UPS — Live rating",
      upsConfigured: "CONNECTED",
      upsNotConfigured: "NOT CONFIGURED",
      upsHint: "Credentials of your UPS Developer app (Rating API). They are encrypted before storage and never sent back to the browser. Leave a field empty to keep the existing value.",
      upsAccount: "UPS ACCOUNT NUMBER (6 chars)",
      upsClientId: "CLIENT ID",
      upsClientSecret: "CLIENT SECRET",
      upsEnvTest: "Test environment (CIE)",
      upsEnvProd: "Production",
      upsTest: "TEST CONNECTION",
      upsClear: "REMOVE CREDENTIALS",
      shipFromTitle: "Atelier ship-from address",
      feesTitle: "Fees & package",
      feesHint: "The handling fee is added to the live UPS rate to form a single “Shipping & Handling” line at checkout. The fallback flat rate applies when UPS is unreachable. The UPS rate is converted to euros at the day's ECB rate.",
      fHandling: "PACKAGING & HANDLING FEE (€)",
      fFallback: "FALLBACK FLAT RATE IF UPS UNREACHABLE (€)",
      fWeight: "PACKAGE WEIGHT PER CANVAS (KG)",
      fDepth: "PACKAGE DEPTH (CM)",
      paidLabel: "PAID",
      availableBtn: "AVAILABLE",
      slidesHint: "MULTIPLE PHOTOS ALLOWED — THE FIRST IS THE COVER",
      cover: "COVER",
      unavailableBtn: "UNAVAILABLE",
      toggleAvailHint: "Toggle available / unavailable",
      tabSubscribers: "SUBSCRIBERS",
      noSubscribers: "No subscribers yet.",
      exportCsv: "EXPORT CSV",
      visibilityTitle: "Visibility & social",
      visibilityHint: "Enter the site's public address (e.g. https://demoivre.com) for link previews and the sitemap, then your social profiles — icons appear in the footer.",
      fSiteUrl: "PUBLIC SITE ADDRESS (https://…)",
      fGoogle: "GOOGLE SEARCH CONSOLE CODE (meta tag, optional)",
      saveSettings: "SAVE",
      settingsSaved: "Settings saved.",
      seoHelpTitle: "Google search",
      seoHelp1: "Sitemap to submit in Google Search Console:",
      seoHelp2: "Home share link (rich preview):",
      seoHelp3: "Every canvas has its own share link via the “Share” buttons on its page.",
      addPiece: "ADD A PIECE",
      editPiece: "EDIT",
      newPiece: "NEW PIECE",
      fTitle: "TITLE",
      fDwg: "DRAWING NO. — E.G. DWG-2026-FR-007",
      fDimensions: "DIMENSIONS — E.G. 40.6 × 50.8 CM / 16 × 20 IN",
      fPrice: "PRICE EUR",
      fMedium: "MEDIUM",
      fYear: "YEAR",
      fEdition: "EDITION",
      fImage: "PHOTOGRAPH URL (PLACEHOLDER OK)",
      fDescription: "DESCRIPTION",
      fStory: "THE MECHANICAL IDEA / STORY OF THE DRAWING",
      enSection: "ENGLISH TRANSLATIONS (OPTIONAL)",
      fTitleEn: "TITLE — ENGLISH",
      fMediumEn: "MEDIUM — ENGLISH",
      fEditionEn: "EDITION — ENGLISH",
      fDescriptionEn: "DESCRIPTION — ENGLISH",
      fStoryEn: "MECHANICAL IDEA — ENGLISH",
      uploadLabel: "UPLOAD A PHOTO",
      uploading: "UPLOADING…",
      uploadOk: "Photo uploaded.",
      uploadErr: "Upload failed.",
      orUrl: "OR PASTE AN IMAGE URL THEN ENTER",
      featured: "FEATURED PIECE (HOMEPAGE)",
      save: "SAVE",
      cancel: "CANCEL",
      saved: "Piece updated.",
      created: "Piece added to the catalogue.",
      saveErr: "Save failed.",
      deleted: "Piece removed from the catalogue.",
      deleteErr: "Delete failed.",
      noOrders: "NO ORDERS YET",
      noInquiries: "NO INQUIRIES YET",
      archetype: "Archetype:",
      format: "Format:",
    },
    store: {
      alreadyIn: "This piece is already in your collection.",
      added: "Canvas added to your collection.",
    },
  },
};
